export default "__VITE_ASSET__D4uRhM6W__"